module.exports = __webpack_public_path__ + "img/1.dcea7967.jpg";